import { render, staticRenderFns } from "./TheLoginPage.vue?vue&type=template&id=36ace2b0&scoped=true&"
import script from "./TheLoginPage.vue?vue&type=script&lang=js&"
export * from "./TheLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./TheLoginPage.vue?vue&type=style&index=0&id=36ace2b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ace2b0",
  null
  
)

export default component.exports